const KNOWN_ACRONYMS = new Set([
  'afro',
  'afrobeats',
  'am',
  'bpm',
  'dj',
  'edm',
  'ep',
  'fx',
  'hiphop',
  'idm',
  'lofi',
  'mix',
  'pm',
  'rnb',
  'sfx',
  'trap',
  'ukg',
]);

function shouldKeepUppercase(word: string): boolean {
  if (!word) return false;
  if (KNOWN_ACRONYMS.has(word.toLowerCase())) return true;

  const hasLetter = /[a-z]/i.test(word);
  return hasLetter && word === word.toUpperCase();
}

function formatWord(word: string): string {
  if (!word) return '';
  if (shouldKeepUppercase(word)) return word.toUpperCase();
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/**
 * Display-only label formatting for tags.
 * - Trims whitespace
 * - Title-cases words
 * - Preserves known and existing uppercase acronyms (e.g. EDM, DJ)
 */
export function formatTagLabel(label: string): string {
  const normalized = label.trim().replace(/\s+/g, ' ');
  if (!normalized) return '';

  return normalized
    .split(' ')
    .map((word) =>
      word
        .split('-')
        .map((part) => formatWord(part))
        .join('-'),
    )
    .join(' ');
}
